import api from '../../api'

export const insert = async (poPreferences, homePageDomain) => {



	let poRequired, beforeAfter, ccRequired
	if (poPreferences.poRequired === undefined) {
		poRequired = false
	} else {
		poRequired = poPreferences.poRequired
	}

	if (poPreferences.beforeAfter === undefined) {
		beforeAfter = false
	} else {
		beforeAfter = poPreferences.beforeAfter
	}

	if (poPreferences.ccRequired === undefined) {
		ccRequired = 3 //set it to NO, which is ID 3
	} else {
		ccRequired = poPreferences.ccRequired
	}

	let restType = (poPreferences.poId) ? 'patch' : 'create'
	let payload = {
		poRequiredBefore: beforeAfter,
		creditCardRulesId: ccRequired,
		poRequired: poRequired
	}
	
	if (restType === 'patch')
	{
		await api.service('billingPreferences').patch(poPreferences.poId, payload)
	} else {
		let ogtPoPreferenceResponse = await api.service('billingPreferences').create(payload)

		await api.service('localAccounts').patch(homePageDomain.id, {
			billingPreferenceId: ogtPoPreferenceResponse.id
		})
	}

	// if (poPreferences.poId) {
	// 	await api.service('poPreferences').patch(poPreferences.poId, {
	// 		required: poRequired,
	// 		requiredBefore: beforeAfter,
	// 	})
	// } else {
	// 	let ogtPoPreferenceResponse = await api.service('poPreferences').create({
	// 		required: poRequired,
	// 		requiredBefore: beforeAfter, 
	// 	})

	// 	await api.service('localAccounts').patch(homePageDomain.id, {
	// 		poPreferenceId: ogtPoPreferenceResponse.id
	// 	})

	// }
}


// WEBPACK FOOTER //
// ./src/database/lbb/poPreferences.js